import { render, staticRenderFns } from "./ComponentsTable.vue?vue&type=template&id=82817510&scoped=true"
import script from "./ComponentsTable.vue?vue&type=script&lang=js"
export * from "./ComponentsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82817510",
  null
  
)

export default component.exports